import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

/** One standard PM type for a unit (EQ-18): stored code and display label ("Type 1 (50 h)"). */
export interface PmTypeOption {
  code: string;
  label: string;
}

/** The unit's PM types (its PM classification's types, then Grease). */
export async function getPmTypes(vehicleId: number): Promise<PmTypeOption[]> {
  try {
    const response = await axios.get(`${BASE_URL}/vehicles/${vehicleId}/pm-types`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error: any) {
    const message = error?.response?.data?.error || error?.message || 'Failed to load PM types';
    throw new Error(message);
  }
}

const equipmentPmService = { getPmTypes };
export default equipmentPmService;
